var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      attrs: { active: _vm.isActive },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _vm._m(0),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Item No.")]),
        _vm.value.isNew
          ? _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control short-width" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.itemNo,
                      expression: "value.itemNo",
                    },
                    { name: "focus-inserted", rawName: "v-focus-inserted" },
                  ],
                  staticClass: "input is-capitalized",
                  class: { "is-danger": _vm.$v.entity.itemNo.$error },
                  attrs: {
                    name: "itemNo",
                    type: "text",
                    placeholder: "Item No",
                    maxlength: "5",
                  },
                  domProps: { value: _vm.value.itemNo },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.value, "itemNo", $event.target.value)
                    },
                  },
                }),
                _vm.$v.entity && !_vm.$v.entity.itemNo.required
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Item No. is required"),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _c("div", { staticClass: "field" }, [
              _c("span", [_vm._v(_vm._s(_vm.value.itemNo))]),
            ]),
      ]),
      _vm.value.isNew
        ? _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "control" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Item Type ")]),
              _c("span", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.value.itemType,
                        expression: "value.itemType",
                      },
                    ],
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.value,
                            "itemType",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        function ($event) {
                          return _vm.onChangeItemType($event)
                        },
                      ],
                    },
                  },
                  [
                    _c(
                      "option",
                      {
                        attrs: { selected: "" },
                        domProps: { value: _vm.itemTypeEnum.LABOUR },
                      },
                      [_vm._v("Labour")]
                    ),
                    _c(
                      "option",
                      { domProps: { value: _vm.itemTypeEnum.PARTS } },
                      [_vm._v("Parts")]
                    ),
                    _c(
                      "option",
                      { domProps: { value: _vm.itemTypeEnum.OPG } },
                      [_vm._v("OPG")]
                    ),
                    _c(
                      "option",
                      { domProps: { value: _vm.itemTypeEnum.MISC } },
                      [_vm._v("Misc")]
                    ),
                    _c(
                      "option",
                      { domProps: { value: _vm.itemTypeEnum.SUBL } },
                      [_vm._v("Sublet")]
                    ),
                  ]
                ),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Item Type ")]),
            _c("span", [_vm._v("Sublet")]),
          ]),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Description")]),
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "control desc-width" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value.itemDesc,
                  expression: "value.itemDesc",
                },
                { name: "focus-inserted", rawName: "v-focus-inserted" },
              ],
              staticClass: "input",
              class: { "is-danger": _vm.$v.entity.itemDesc.$error },
              attrs: {
                name: "itemDesc",
                type: "text",
                placeholder: "Description",
                maxlength: "100",
              },
              domProps: { value: _vm.value.itemDesc },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.value, "itemDesc", $event.target.value)
                },
              },
            }),
            _vm.$v.entity && !_vm.$v.entity.itemDesc.required
              ? _c("span", { staticClass: "help is-danger" }, [
                  _vm._v("Description is required"),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field is-narrow" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Sort Number")]),
            _c(
              "div",
              { staticClass: "control" },
              [
                _c("vue-numeric", {
                  staticClass: "input has-text-right",
                  attrs: { precision: 0, maxlength: "5" },
                  model: {
                    value: _vm.value.sortNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "sortNo", _vm._n($$v))
                    },
                    expression: "value.sortNo",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field is-narrow" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Sublet Dollar")]),
            _c(
              "div",
              { staticClass: "control" },
              [
                _c("vue-numeric", {
                  staticClass: "input has-text-right",
                  attrs: { precision: 2 },
                  model: {
                    value: _vm.value.rrHour,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "rrHour", _vm._n($$v))
                    },
                    expression: "value.rrHour",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-gapless" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Detail Info")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }